import React from "react";
import { Box } from "@mui/material";
import { useWindowSize } from "@uidotdev/usehooks";
import SabiasQue from "../SabiasQue";

// Template137: Día 4 - Gangnam y COEX
const Template137 = ({
	backgroundColor,
	headerBackgroundColor,
	headerTextColor,
	fontFamily,
	page,
}) => {
	const size = useWindowSize();
	const isSmallScreen = size.width <= 600;

	const headerText = page?.texts?.[0]?.content;
	const deSeongsuTitle = page?.texts?.[1]?.content;
	const deSeongsuList = page?.texts?.[2]?.content;
	const pFueraCoex = page?.texts?.[3]?.content;
	const gangnamStyleTitle = page?.texts?.[4]?.content;
	const gangnamStyleDesc = page?.texts?.[5]?.content;
	const sabiasQuePsy = page?.texts?.[6]?.content;
	const bongeunsaTitle = page?.texts?.[7]?.content;
	const bongeunsaDesc = page?.texts?.[8]?.content;
	const pGangnamZona = page?.texts?.[9]?.content;
	const kstarTitle = page?.texts?.[10]?.content;
	const kstarDesc = page?.texts?.[11]?.content;
	const sabiasQueOsos = page?.texts?.[12]?.content;
	const apgujeongTitle = page?.texts?.[13]?.content;
	const apgujeongDesc = page?.texts?.[14]?.content;
	const sabiasQueBanpo = page?.texts?.[15]?.content;

	const getImageSrc = (id) => {
		if (page?.images && Array.isArray(page.images)) {
			const found = page.images.find((img) => img?.id === id);
			if (found && found.src) return found.src;
		}
		return undefined;
	};

	const getCanvasImageUrl = (id) => {
		if (page?.canvasImages && Array.isArray(page.canvasImages)) {
			const found = page.canvasImages.find((img) => img?.id === id);
			if (found && found.imageUrl) return found.imageUrl;
		}
		return undefined;
	};

	const estatuaImage = getImageSrc("estatua");
	const bongeunsaImage = getImageSrc("bongeunsa");
	const kstarImage = getImageSrc("kstar");
	const apgujeongImage = getImageSrc("apgujeong");
	const kstarSticker = getCanvasImageUrl("kstar-sticker");
	const logoImage = getCanvasImageUrl("logo");

	const actualHeaderColor = headerBackgroundColor || "#2E8B80";

	const estiloH3 = {
		fontFamily: `${fontFamily || "'Poppins', sans-serif"} !important`,
		fontSize: 14,
		fontWeight: 700,
		textTransform: "uppercase",
		margin: 0,
	};

	const estiloP = {
		fontFamily: `${fontFamily || "'Poppins', sans-serif"} !important`,
		fontSize: 13,
		color: "#444",
		margin: 0,
	};

	return (
		<Box
			sx={{
				display: "flex",
				flexDirection: "column",
				minHeight: "100%",
				height: "auto",
				width: "100%",
				backgroundColor: backgroundColor || "#f7f7f7",
				position: "relative",
				fontFamily: `${fontFamily || "'Poppins', sans-serif"} !important`,
				"& *": { fontFamily: `${fontFamily || "'Poppins', sans-serif"} !important` },
			}}
		>
			{headerText && (
				<Box
					data-block-id="header"
					data-template-header
					sx={{
						backgroundColor: actualHeaderColor,
						color: headerTextColor || "#fff",
						textAlign: "center",
						padding: "15px 0",
						fontFamily: `${fontFamily || "'Poppins', sans-serif"}`,
						fontSize: "14px",
						fontWeight: 800,
						flexShrink: 0,
						position: "sticky",
						top: 0,
						zIndex: 99999,
					}}
				>
					{headerText}
					{logoImage && !isSmallScreen && (
						<Box
							component="img"
							src={logoImage}
							alt="logo"
							sx={{
								width: 80,
								position: "absolute",
								right: 2,
								top: 18,
								zIndex: 999999,
							}}
						/>
					)}
				</Box>
			)}

			<Box sx={{ padding: "10px 12px", position: "relative" }}>
				{(deSeongsuTitle || deSeongsuList) && (
					<Box
						data-block-id="text-1"
						sx={{
							backgroundColor: "#caeae6",
							border: "3px solid #2e8b80",
							borderRadius: "12px",
							padding: "16px 20px",
							fontSize: 12,
							fontFamily: "'Poppins', sans-serif",
							color: "#333",
							width: "100%",
							position: "relative",
							marginBottom: 0,
						}}
					>
						{deSeongsuTitle && (
							<Box component="h4" sx={{ margin: 0, marginBottom: "8px", fontSize: 13, fontWeight: 700, display: "flex", alignItems: "center", gap: 6, color: "#2e8b80", textTransform: "uppercase" }}>
								{deSeongsuTitle}
							</Box>
						)}
						{deSeongsuList && (
							<Box component="ul" sx={{ paddingLeft: "20px", margin: 0, lineHeight: 1.5 }}>
								{deSeongsuList.split(". ").map((line, i) => (line ? <li key={i}>{line}</li> : null))}
							</Box>
						)}
					</Box>
				)}

				<Box sx={{ display: "flex", flexDirection: "column", gap: "12px", marginTop: "16px" }}>
					{pFueraCoex && (
						<Box component="p" sx={{ fontFamily: "'Poppins', sans-serif", fontSize: 13, color: "#333", margin: 0, padding: 0 }}>
							{pFueraCoex}
						</Box>
					)}

					{(gangnamStyleTitle || gangnamStyleDesc || estatuaImage) && (
						<Box data-block-id="text-2" sx={{ display: "flex", gap: "16px", position: "relative" }}>
							{estatuaImage && (
								<img src={estatuaImage} alt="" style={{ width: "40%", height: 110, objectFit: "cover", borderRadius: 12 }} />
							)}
							<Box sx={{ width: "60%" }}>
								{gangnamStyleTitle && <Box component="h3" sx={estiloH3}>{gangnamStyleTitle}</Box>}
								{gangnamStyleDesc && <Box component="p" sx={estiloP}>{gangnamStyleDesc}</Box>}
							</Box>
							{sabiasQuePsy && (
								<Box sx={{ position: "absolute", top: isSmallScreen ? 60 : 40, left: "33%" }}>
									<SabiasQue icono="💃" texto={sabiasQuePsy} />
								</Box>
							)}
						</Box>
					)}

					{(bongeunsaTitle || bongeunsaDesc) && (
						<Box data-block-id="text-3" sx={{ display: "flex", gap: "16px", position: "relative" }}>
							<Box sx={{ width: "100%" }}>
								<Box sx={{ ...estiloP, padding: "12px", backgroundColor: "#caeae6", borderRadius: "12px" }}>
									{bongeunsaImage && (
										<img src={bongeunsaImage} alt="" style={{ width: isSmallScreen ? 105 : 115, float: "right", marginRight: -34, marginTop: -40 }} />
									)}
									{bongeunsaTitle && <Box component="h3" sx={estiloH3}>{bongeunsaTitle}</Box>}
									{bongeunsaDesc && <Box component="span">{bongeunsaDesc}</Box>}
								</Box>
							</Box>
						</Box>
					)}

					{pGangnamZona && (
						<Box component="p" sx={{ fontFamily: "'Poppins', sans-serif", fontSize: 13, color: "#333", margin: 0, padding: 0 }}>
							{pGangnamZona}
						</Box>
					)}

					{(kstarTitle || kstarDesc || kstarImage) && (
						<Box data-block-id="text-4" sx={{ display: "flex", gap: "16px", position: "relative" }}>
							{kstarImage && (
								<img src={kstarImage} alt="" style={{ width: "40%", height: 110, objectFit: "cover", borderRadius: 12 }} />
							)}
							<Box sx={{ width: "60%" }}>
								{kstarTitle && <Box component="h3" sx={estiloH3}>{kstarTitle}</Box>}
								{kstarDesc && <Box component="p" sx={estiloP}>{kstarDesc}</Box>}
							</Box>
							{sabiasQueOsos && (
								<Box sx={{ position: "absolute", top: isSmallScreen ? 60 : 40, left: "33%" }}>
									<SabiasQue icono="🐻" texto={sabiasQueOsos} />
								</Box>
							)}
						</Box>
					)}

					{(apgujeongTitle || apgujeongDesc || apgujeongImage) && (
						<Box data-block-id="text-5" sx={{ display: "flex", gap: "16px", position: "relative" }}>
							{apgujeongImage && (
								<img src={apgujeongImage} alt="" style={{ width: "40%", height: 110, objectFit: "cover", borderRadius: 12 }} />
							)}
							<Box sx={{ width: "60%" }}>
								{apgujeongTitle && <Box component="h3" sx={estiloH3}>{apgujeongTitle}</Box>}
								{apgujeongDesc && <Box component="p" sx={estiloP}>{apgujeongDesc}</Box>}
							</Box>
							{kstarSticker && (
								<img src={kstarSticker} alt="" style={{ width: 110, position: "absolute", bottom: -10, left: -20, zIndex: 2 }} />
							)}
							{sabiasQueBanpo && (
								<Box sx={{ position: "absolute", top: -10, left: "33%" }}>
									<SabiasQue icono="🌈" texto={sabiasQueBanpo} />
								</Box>
							)}
						</Box>
					)}
				</Box>
			</Box>
		</Box>
	);
};

Template137.thumbnail = "/images/template-1.png";

export default Template137;
